import { PureComponent } from "react";
import { componentStyles } from "./badge-component.scss";
import { withGenericConfig } from "contexts/generic-config-context";
import Colors from "/styles/colors";

class BadgeComponent extends PureComponent {
  render() {
    const { translate, badgeText, badgeColorName, badgeTextColorName } = this.props;

    return (
      <span className="core-badge-component" style = {{backgroundColor: Colors[badgeColorName], color: Colors[badgeTextColorName] }}>
        {badgeText || translate("header.menuItem.popular")}
        <style jsx>{componentStyles}</style>
      </span>
    );
  }
}

export default withGenericConfig(BadgeComponent);
